export const EMAIL_LABEL: string = "Email";
export const PASSWORD_LABEL: string = "Password";
export const USERNAME_LABEL: string = "User Name";
export const NEW_PASSWORD_LABEL: string = "New Password";
export const CONFIRM_PASSWORD_LABEL: string = "Confirm Password";
export const NEW_PASSWORD: string = "newPassword";
export const CONFIRM_PASSWORD: string = "confirmPassword";
export const EMAIL: string = "email";
export const PASSWORD: string = "password";
